export default __webpack_public_path__ + "static/bud-case-0e4c4b6928512d1773ebe6373b48c85c.svg";